"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactLabel = void 0;
var ContactLabel;
(function (ContactLabel) {
    ContactLabel["PRIMARY"] = "Primary";
    ContactLabel["INVITED"] = "Invited";
})(ContactLabel || (exports.ContactLabel = ContactLabel = {}));
